"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectInput = exports.SelectIcon = exports.SelectValue = exports.SelectLabel = exports.SelectContainer = void 0;
const react_1 = __importDefault(require("react"));
const Theme_1 = require("../../Theme/Theme");
const SingleSelectMenu_1 = require("../Menus/SingleSelectMenu");
const Icon_1 = __importDefault(require("../Icon/Icon"));
exports.SelectContainer = Theme_1.styled.div `
  width: ${(props) => (props.width ? props.width - 20 + 'px' : 'auto')};
  background-color: ${(props) => props.theme.gray5};
  background: ${(props) => props.variant === 'filled' ? props.theme.gray5 : 'transparent'};
  padding: 19px 10px 19px 10px;
  border: none;
  border-bottom: 1px solid ${(props) => props.theme.gray4};
  outline: none;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  font-family: ${(props) => props.theme.font.family.proximaNova};
  font-size: 16px;
  color: ${(props) => props.theme.gray2};
  white-space: nowrap;
  &:hover {
    cursor: pointer;
  }
`;
exports.SelectLabel = Theme_1.styled.div `
  font-family: ${(props) => props.theme.font.family.proximaNova};
  color: ${(props) => props.theme.gray2};
  ${(props) => props.hasValue &&
    `position: absolute;
  top: 6px;
  left: 9px;
  font-size: 12px;`}
`;
exports.SelectValue = Theme_1.styled.div `
  font-family: ${(props) => props.theme.font.family.proximaNova};
  font-size: 16px;
  position: relative;
  top: 9px;
  overflow: hidden;
  text-overflow: ellipsis;
`;
exports.SelectIcon = Theme_1.styled.div `
  position: absolute;
  right: 9px;
  top: 22px;
`;
exports.SelectInput = (props) => {
    const { width, value, options, label, onOptionSelected } = props;
    return (react_1.default.createElement(SingleSelectMenu_1.SingleSelectMenu, { width: width
            ? width + 'px'
            : '-moz-available; width: -webkit-fill-available; width: fill-available; width:100%', VisualElement: react_1.default.createElement(exports.SelectContainer, Object.assign({}, props, { className: "inputContainer" }),
            value && react_1.default.createElement(exports.SelectValue, null, value),
            react_1.default.createElement(exports.SelectLabel, { hasValue: value }, label),
            react_1.default.createElement(exports.SelectIcon, null,
                react_1.default.createElement(Icon_1.default, { icon: "triangleDown", size: "12", onClick: () => {
                        return;
                    } }))), onOptionSelected: (option) => onOptionSelected(option), selectedOption: value, menuOptions: options, menuLocation: "below" }));
};
exports.default = exports.SelectInput;
//# sourceMappingURL=SelectInput.js.map